import { useCallback, useSyncExternalStore } from 'react';

/**
 * Reactive `window.matchMedia` — re-renders when the query flips.
 * `fallback` is returned where matchMedia is unavailable (jsdom, SSR).
 */
export default function useMediaQuery(query: string, fallback = false): boolean {
  const supported =
    typeof window !== 'undefined' && typeof window.matchMedia === 'function';

  const subscribe = useCallback(
    (onChange: () => void) => {
      if (!supported) return () => {};
      const mql = window.matchMedia(query);
      mql.addEventListener('change', onChange);
      return () => mql.removeEventListener('change', onChange);
    },
    [query, supported],
  );

  const getSnapshot = () =>
    supported ? window.matchMedia(query).matches : fallback;

  return useSyncExternalStore(subscribe, getSnapshot, () => fallback);
}

/** Tailwind `lg` in this project (see index.css `--breakpoint-lg`). */
export const DESKTOP_MEDIA_QUERY = '(min-width: 1024px)';
